import { Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent {

  // Specific inputs instead of entire parent
  @Input() teleportationEnable: boolean = false;
  @Input() filtersEnable: boolean = false;
  @Input() vegBoostEnable: boolean = false;
  @Input() refreshMyData?:  () => void; 
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() unregisterFunction!: any;

  @Output() teleportationClicked = new EventEmitter<void>();
  @Output() preferencesClicked = new EventEmitter<void>();
  
  constructor() { }
}
